import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/common-utils/components/ui/sidebar';
import ICONS from '@/common-utils/enums/icons';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';


/**
 *
 */
function SidebarPreviousButton({ dynamicTextColor, linkClassName }) {

    // State
    const [previousUrl, setPreviousUrl] = useState(null);

    // Hooks
    const location = useLocation();

    useEffect(() => {
        const regex = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

        const urlSplitted = location.pathname.split('/');
        const urlSplittedLength = urlSplitted.length;

        if (urlSplitted[urlSplittedLength - 1].match(regex)) {
            urlSplitted.pop();
            urlSplitted.pop();
        } else {
            urlSplitted.pop();
        }
        setPreviousUrl(`${urlSplitted.join('/')}${location.search}`);
    }, [location]);

    return (
        <SidebarMenu className='p-2'>
            <SidebarMenuItem>
                <SidebarMenuButton className={linkClassName} asChild>
                    <Link to={previousUrl}>
                        <Icon icon={ICONS.ARROW_LEFT} />
                        <Entity entity='sidebar.actions.previous' style={{ color: dynamicTextColor }} />
                    </Link>
                </SidebarMenuButton>
            </SidebarMenuItem>
        </SidebarMenu>
    );
}

SidebarPreviousButton.propTypes = {
    dynamicTextColor: PropTypes.string.isRequired,
    linkClassName: PropTypes.string
};

export default SidebarPreviousButton;